const _buildFileCard = (file, baseClass) => {
  const ext = (file.name.split('.').pop() || '?').toLowerCase();
  const el = document.createElement('div');
  el.className = `${baseClass} file-card`;

  const icon = document.createElement('div');
  icon.className = `file-type-icon ${ext}`;
  icon.textContent = ext;
  el.appendChild(icon);

  const info = document.createElement('div');
  info.className = 'file-info';

  const name = document.createElement('div');
  name.className = 'file-name';
  name.textContent = file.name;
  info.appendChild(name);

  const label = document.createElement('div');
  label.className = 'file-ext-label';
  label.textContent = ext.toUpperCase();
  info.appendChild(label);

  el.appendChild(info);
  return el;
};

const _buildImageCard = (file, baseClass) => {
  const el = document.createElement('div');
  el.className = baseClass;
  const img = document.createElement('img');
  img.src = URL.createObjectURL(file);
  el.appendChild(img);
  return el;
};

export const appendAttachment = (messageGroup, file) => {
  let bubble = messageGroup.querySelector('.aws-chatkit-bubble');
  if (!bubble) {
    bubble = document.createElement('div');
    bubble.className = 'aws-chatkit-bubble';
    messageGroup.appendChild(bubble);
  }

  const el = file.type.startsWith('image/')
    ? _buildImageCard(file, 'aws-chatkit-message-attachment')
    : _buildFileCard(file, 'aws-chatkit-message-attachment');

  bubble.appendChild(el);
};

export const clearAttachmentPreviews = (container) => {
  const previewArea = container.querySelector('.aws-chatkit-attachments-preview');
  if (!previewArea) return;
  previewArea.innerHTML = '';
  previewArea.classList.remove('has-files');
};

export const appendAttachmentPreview = (container, file, onRemove) => {
  const previewArea = container.querySelector('.aws-chatkit-attachments-preview');
  if (!previewArea) return;

  previewArea.classList.add('has-files');

  const thumb = file.type.startsWith('image/')
    ? _buildImageCard(file, 'aws-chatkit-attachment-thumb')
    : _buildFileCard(file, 'aws-chatkit-attachment-thumb');

  const removeBtn = document.createElement('button');
  removeBtn.className = 'aws-chatkit-attachment-remove';
  removeBtn.innerHTML = '&#10005;';
  removeBtn.addEventListener('click', onRemove);
  thumb.appendChild(removeBtn);

  previewArea.appendChild(thumb);
};
